import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Cómo recibo el Pack después de comprar?',
  a: 'Inmediatamente después de confirmar el pago recibís un correo con el link de descarga de todos los archivos en formato PDF. El acceso es instantáneo, las 24 horas, los 7 días de la semana.'
}, {
  q: '¿Sirve si soy docente de una sola sección o de un solo grado?',
  a: 'Sí. Cada tomo funciona de manera independiente. Si enseñás 3° grado, abrís el Tomo 3 y el Bono 3 y ya tenés todo lo que necesitás para el año. Los demás tomos son un recurso adicional que podés usar como referencia o compartir con colegas.'
}, {
  q: '¿Necesito tecnología especial para usarlo?',
  a: 'No. Todo el Pack es en formato PDF. Lo podés abrir en cualquier computadora, tablet o celular. Las fichas están diseñadas para imprimir en A4 estándar en cualquier fotocopiadora.'
}, {
  q: '¿Los 6 bonos de ficheros están incluidos en las dos opciones?',
  a: 'Sí. Ambas opciones incluyen los 6 tomos más los 6 ficheros imprimibles completos (30 páginas por grado, 180 páginas en total de material para el alumno). El Master Kit de Evaluación se agrega únicamente en el Pack Completo.'
}, {
  q: '¿Sirve si enseño en escuela pública sin recursos?',
  a: 'Fue diseñado exactamente para eso. Las fichas solo necesitan una fotocopiadora. Los recursos concretos sugeridos son tapitas, billetes de papel imprimibles y materiales reciclables. Sin tecnología, sin costo extra.'
}, {
  q: '¿Sirve si tengo un grupo muy heterogéneo?',
  a: 'Sí. Cada fichero incluye actividades con 3 niveles de complejidad (reproducción, conexión y reflexión) para que puedas adaptar en minutos. Además, el Bono 4 de quinto grado incluye la guía de adaptación por ritmos de aprendizaje.'
}, {
  q: '¿Qué diferencia tiene con las planificaciones gratuitas de internet?',
  a: 'Las planificaciones gratuitas son genéricas, sin progresión real, sin fichas para el alumno y sin evaluaciones. Este Pack es un sistema coherente de 1° a 6° grado, alineado al CFE, con material listo para usar en el aula desde el lunes. No es un documento para cumplir. Es una herramienta para enseñar mejor.'
}, {
  q: '¿Por qué elegir el Pack Completo y no solo los tomos?',
  a: 'El Pack Completo agrega el Master Kit de Evaluación™: 60 páginas con 18 exámenes listos, rúbricas, planillas de registro y herramientas administrativas. Si querés tener también las evaluaciones, los informes y la documentación resuelta, el Pack Completo es la única opción que lo tiene todo.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí. 7 días de garantía total. Si por cualquier motivo el Pack no es lo que esperabas, te devolvemos el 100% del dinero. Sin formularios complicados. Sin preguntas. Sin demoras.'
}];
export const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-white" data-id="element-70">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-71">
        <div className="text-center mb-12" data-id="element-72">
          <h2 className="text-sm font-bold text-brand-orange tracking-widest uppercase mb-2" data-id="element-73">
            DUDAS COMUNES
          </h2>
          <h3 className="text-3xl md:text-4xl font-heading font-bold text-gray-900" data-id="element-74">
            PREGUNTAS FRECUENTES
          </h3>
        </div>

        <div className="space-y-4" data-id="element-75">
          {faqs.map((faq, i) => <div key={i} className="border-b border-gray-200 pb-2" data-id="element-76">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full py-4 flex items-center justify-between text-left focus:outline-none" data-id="element-77">
                <span className="font-bold text-gray-900 pr-8" data-id="element-78">{faq.q}</span>
                <ChevronDown className={`text-brand-orange flex-shrink-0 transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-79" />
              </button>
              <AnimatePresence data-id="element-80">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-81">
                    <p className="text-gray-600 pb-6 leading-relaxed" data-id="element-82">
                      {faq.a}
                    </p>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
};